import { createContext, useContext } from "react";

import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { useCurrentCursorContext } from "@/components/input/CursorContextProvider";

import type { NodeRenderContext } from "@/components/expression/utils/NodeStyleProvider";
import type { NodeModel } from "@/models/nodes/types";

export const SelectedContext = createContext(false);

export function useIsSelected(node?: NodeModel, renderContext?: NodeRenderContext) {
  const isContextSelected = useContext(SelectedContext);
  const style = useNodeStyle();
  const expectedRenderContext = renderContext ?? style.renderContext;
  const { selection } = useCurrentCursorContext(node?.doc);

  if (style.renderContext !== expectedRenderContext) {
    return false;
  }

  if (!node) {
    return isContextSelected;
  }

  const isSelected = isContextSelected || !!selection?.isSelected(node);
  const isActive = !!selection?.isActive(node);

  return isSelected || isActive;
}
